var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216.556,
    height: 44.43,
    viewBox: "0 0 216.556 44.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 513 544"
  }, /*#__PURE__*/React.createElement("image", {
    width: 513,
    height: 544,
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_338",
    x: 0.157,
    y: 10.795,
    width: 48.81,
    height: 33.635,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mirrorfly_logo_color",
    "data-name": "Mirrorfly logo color",
    transform: "translate(-1.105 -0.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M588.6,2027.319v21.523a2.675,2.675,0,0,1-1.3,2.366,2.613,2.613,0,0,1-2.674,0,2.675,2.675,0,0,1-1.3-2.366v-12.873l-4.841,7.7c-.741,1.186-1.444,1.7-2.5,1.7a2.867,2.867,0,0,1-2.5-1.7l-4.841-7.779v12.954a2.636,2.636,0,1,1-5.272,0v-21.523a2.638,2.638,0,0,1,.7-1.943,2.577,2.577,0,0,1,1.876-.824c1.132,0,1.874.555,2.773,2.055l7.261,11.651,7.261-11.651c.937-1.5,1.639-2.054,2.773-2.054a2.574,2.574,0,0,1,1.876.824,2.638,2.638,0,0,1,.7,1.943",
    transform: "translate(-502.871 -2017.645)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M709.859,2035.7v-14.872a2.635,2.635,0,0,1,5.27,0V2035.7a2.635,2.635,0,0,1-5.27,0m5.934-24.127a3.3,3.3,0,1,1-3.28-3.2,3.25,3.25,0,0,1,3.28,3.2",
    transform: "translate(-618.589 -2004.781)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M775.9,2058.732a2.511,2.511,0,0,1-2.459,2.536c-2.81.2-4.529,2.033-4.529,5v7.418a2.589,2.589,0,0,1-2.616,2.7,2.62,2.62,0,0,1-2.654-2.7v-14.874a2.575,2.575,0,0,1,2.616-2.652,2.527,2.527,0,0,1,2.538,2.376,6.3,6.3,0,0,1,4.723-2.185,2.253,2.253,0,0,1,2.382,2.378",
    transform: "translate(-661.754 -2042.57)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M849.752,2058.732a2.511,2.511,0,0,1-2.46,2.536c-2.811.2-4.529,2.033-4.529,5v7.418a2.588,2.588,0,0,1-2.615,2.7,2.62,2.62,0,0,1-2.655-2.7v-14.874a2.574,2.574,0,0,1,2.615-2.652,2.527,2.527,0,0,1,2.538,2.377,6.3,6.3,0,0,1,4.724-2.185,2.252,2.252,0,0,1,2.381,2.378",
    transform: "translate(-720.338 -2042.569)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M909.467,2066.262a5,5,0,1,0,9.994,0,5.006,5.006,0,1,0-9.994,0m15.381-.039a10.208,10.208,0,0,1-10.42,10.112,10.1,10.1,0,1,1,10.422-10.112",
    transform: "translate(-773.14 -2042.567)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1037.432,2058.732a2.511,2.511,0,0,1-2.46,2.536c-2.81.2-4.529,2.033-4.529,5v7.418a2.587,2.587,0,0,1-2.615,2.7,2.62,2.62,0,0,1-2.654-2.7v-14.874a2.575,2.575,0,0,1,2.617-2.652,2.527,2.527,0,0,1,2.536,2.376,6.3,6.3,0,0,1,4.722-2.185,2.254,2.254,0,0,1,2.383,2.378",
    transform: "translate(-869.21 -2042.57)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1104.936,2052.005v-24.1a1.045,1.045,0,0,1,.3-.764,1.02,1.02,0,0,1,.754-.3h13.858a.913.913,0,0,1,.656.258.934.934,0,0,1,.282.652.955.955,0,0,1-.938.946h-12.882v10.076h10.58a.921.921,0,0,1,.936.908.954.954,0,0,1-.936.948h-10.58v11.378a1.071,1.071,0,0,1-.28.766,1.047,1.047,0,0,1-.735.339,1.025,1.025,0,0,1-.742-.332,1.048,1.048,0,0,1-.272-.773",
    transform: "translate(-932.206 -2019.464)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1202.59,2052.485v-24.45a.975.975,0,1,1,1.95,0v24.45a.96.96,0,0,1-.276.708.939.939,0,0,1-.7.28.961.961,0,0,1-.693-.287.981.981,0,0,1-.282-.7",
    transform: "translate(-1009.835 -2019.63)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1253.975,2059.606a1.162,1.162,0,0,1-.118.424l-9.135,20.535c-1.444,3.2-3.552,4.722-6.4,4.722a7.58,7.58,0,0,1-1.639-.153.949.949,0,0,1-.783-.9.908.908,0,0,1,.9-.9c.311,0,.9.158,1.367.158,2.185,0,3.669-1.093,4.722-3.437l1.093-2.538-7.731-17.448a1.191,1.191,0,0,1-.118-.467.968.968,0,0,1,.975-.982,1,1,0,0,1,.938.667l7.027,15.849,6.948-15.849a1.013,1.013,0,0,1,.977-.667,1,1,0,0,1,.976.982",
    transform: "translate(-1036.315 -2044.418)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(1.105 0.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M277.266,2152.26l10.682,8.294a1.16,1.16,0,0,0,1.87-.917v-7.375",
    transform: "translate(-277.208 -2121.35)",
    fill: "#0dcea6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M346.3,2034.052v24.3a1.493,1.493,0,0,1-1.544,1.436h-39.88a1.424,1.424,0,0,1-.832-2.647l40.372-24.054a1.23,1.23,0,0,1,1.884.961Z",
    transform: "translate(-297.342 -2027.662)",
    fill: "#ffd119"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M276,2007.374v29.375a1.747,1.747,0,0,0,1.76,1.736h45.462a1.715,1.715,0,0,0,1.685-1.232,1.739,1.739,0,0,0-.736-1.966l-46.023-29.074a1.386,1.386,0,0,0-1.41-.054A1.412,1.412,0,0,0,276,2007.374Z",
    transform: "translate(-276 -2005.992)",
    fill: "#ff0935"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338-2",
    "data-name": "Path 338",
    d: "M365.814,2116.219a1.792,1.792,0,0,0-1.736-1.8,1.859,1.859,0,0,0-1.819,1.816,1.816,1.816,0,0,0,1.8,1.747A1.764,1.764,0,0,0,365.814,2116.219Zm-9.37,1.794a1.771,1.771,0,0,0,1.751-1.776,1.807,1.807,0,0,0-1.751-1.791,1.859,1.859,0,0,0-1.811,1.828A1.821,1.821,0,0,0,356.444,2118.013Zm-7.627.042a1.778,1.778,0,0,0,1.753-1.78,1.818,1.818,0,0,0-1.762-1.789,1.854,1.854,0,0,0-1.8,1.832A1.815,1.815,0,0,0,348.817,2118.056Z",
    transform: "translate(-331.85 -2091.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M409.16,2073.223l5.046-2.984,15.6,15.976Z",
    transform: "translate(-381.223 -2056.597)",
    opacity: 0.15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.6915356c.svg";
export { ForwardRef as ReactComponent };